/* 2009-2018 Copyright Ridecell Inc. All rights reserved. */
module.exports = navigator // eslint-disable-line no-undef
